export enum CardRouterOrigin{
  EXTERNAL_LINK ='external-link',
  WORKFLOW ='workflow'
}
